import * as React from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";

import {
  useQueryGetBenefitGroupMappingPage,
  useMutateDeleteBenefitGroupMapping,
} from "../../data/services/benefitPlanService";

import DeleteDialog from "../../components/DeleteDialog";
import ErrorBanner from "../../components/ErrorBanner";
import AddEditBenefitGroupModel from "./AddEditBenefitGroupModel";
import { createPortal } from "react-dom";

const BenefitGroupMapGrid = ({ title, offerType }) => {
  const [openEditForm, setOpenEditForm] = React.useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = React.useState(false);
  const [editItem, setEditItem] = React.useState();
  const gridRef = React.useRef(null);

  const [gridDataState, setGridDataState] = React.useState({
    take: 20,
    skip: 0,
    sort: [],
  });

  const page = Math.floor(gridDataState.skip / gridDataState.take) + 1;

  const { isFetching, data: apiResponse } = useQueryGetBenefitGroupMappingPage(
    page,
    gridDataState.take,
    offerType,
    gridDataState.sort,
  );

  const pagedData = apiResponse?.data;
  const useMutateDeleteBenefitGroupMappingHandler =
    useMutateDeleteBenefitGroupMapping();

  const pagerSetting = {
    buttonCount: 5,
    info: true,
    type: "numeric",
    pageSizes: [10, 20, 50, 100],
    previousNext: true,
  };

  const handleDataStateChange = (event) => {
    setGridDataState(event.dataState);
  };

  const handleDelete = async (item) => {
    await useMutateDeleteBenefitGroupMappingHandler.mutateAsync({
      bpBenefitGroupMappingId: item.bpBenefitGroupMappingId,
      offerType: offerType,
    });
    setShowDeleteDialog(false);
  };

  const loadingPanelMarkup = (
    <div className="k-loading-mask">
      <span className="k-loading-text">Loading</span>
      <div className="k-loading-image" />
      <div className="k-loading-color" />
    </div>
  );

  const LoadingPanel = (props) => {
    const { gridRef } = props;
    const gridContent =
      gridRef.current && gridRef.current.querySelector(".k-grid-content");
    return gridContent
      ? createPortal(loadingPanelMarkup, gridContent)
      : loadingPanelMarkup;
  };

  const actionCell = (props) => (
    <td>
      <Button
        themeColor="primary"
        onClick={() => {
          setEditItem(props.dataItem);
          setOpenEditForm(true);
        }}
      >
        Edit
      </Button>
      <Button
        themeColor="light"
        style={{ marginLeft: 10 }}
        onClick={() => {
          setEditItem(props.dataItem);
          setShowDeleteDialog(true);
        }}
      >
        Delete
      </Button>
    </td>
  );

  return (
    <div>
      <div
        style={{
          justifyContent: "space-between",
          display: "flex",
          paddingBottom: 10,
        }}
      >
        <div>
          <h2 style={{ margin: "10px" }}>{title}</h2>
        </div>
        <div style={{ alignSelf: "center" }}>
          <Button
            onClick={() => {
              setEditItem({});
              setOpenEditForm(true);
            }}
            themeColor={"primary"}
          >
            Add New
          </Button>
        </div>
      </div>

      <ErrorBanner
        handler={useMutateDeleteBenefitGroupMappingHandler}
        onError={() => setShowDeleteDialog(false)}
      />
      {isFetching ? <LoadingPanel gridRef={gridRef} /> : null}
      <Grid
        style={{ height: "600px" }}
        pageable={pagerSetting}
        sortable={{ allowUnsort: true, mode: "multiple" }}
        loading={isFetching}
        data={pagedData?.items || []}
        total={pagedData?.totalCount || 0}
        {...gridDataState}
        onDataStateChange={handleDataStateChange}
      >
        <Column field="planId" title="Plan Id" />
        <Column field="planName" title="Plan" />
        <Column field="benefitGroup" title="Benefit Group" />
        <Column title="Action" cell={actionCell} sortable={false} />
      </Grid>

      {openEditForm && (
        <AddEditBenefitGroupModel
          cancelEdit={() => setOpenEditForm(false)}
          onSubmit={() => setOpenEditForm(false)}
          item={editItem}
          offerType={offerType}
          lookup={pagedData?.items || []}
        />
      )}

      {showDeleteDialog && (
        <DeleteDialog
          onDelete={handleDelete}
          onCancel={() => setShowDeleteDialog(false)}
          item={editItem}
        />
      )}
    </div>
  );
};

export default BenefitGroupMapGrid;
